import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "avatar plus-more link-color"
}

import {computed} from 'vue';
import {IOperator} from "~/chat/ts/data/IOperator";


const __default__ = {
    name: "Avatars"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    operators: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let plusMore = computed(() => {
    let count = props.operators.length;
    return count > 4 ? count - 3 : 0;
});

let visibleOperators = computed(() => {
    let operators = props.operators
        .filter(operator => !!operator.avatar);
    return plusMore.value ? operators.splice(0, operators.length - plusMore.value) : operators;
});


return (_ctx: any,_cache: any) => {
  return (_unref(visibleOperators).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleOperators), (operator) => {
          return (_openBlock(), _createElementBlock("img", {
            key: operator.id,
            src: operator.avatar,
            class: "avatar",
            onClick: ($event: any) => (_unref(emits)('click', {operator, originalEvent: $event}))
          }, null, 8, _hoisted_2))
        }), 128)),
        (_unref(plusMore))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " +" + _toDisplayString(_unref(plusMore)), 1))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "clear" }, null, -1))
      ]))
    : _createCommentVNode("", true)
}
}

})